// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".waybill-table[data-v-6774c862] {\n  height: 0;\n}\n.show-waybill[data-v-6774c862] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
